import Section from "./Section";
import Row from "./Row";
import { motion } from "framer-motion";

// ✅ your animations
import { fadeUp, fadeIn, slideLeft, slideRight } from "animations/variants";

const RestaurantInfo = ({ order }) => {
  const safe = (val, fallback = "-") => val || fallback;

  return (
    <motion.div variants={slideRight}>
      <Section title="Restaurant">
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <p className="font-semibold">{safe(order?.operator?.name)}</p>
            <p>{safe(order?.operator?.phone)}</p>
            <p>{safe(order?.operator?.email)}</p>
          </div>

          <div>
            <Row label="Method" value="Pickup" />
            <Row label="Fee" value="-" />
          </div>
        </div>
      </Section>
    </motion.div>
  );
};

export default RestaurantInfo;
